export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5594.c1a9b8f0.jpg";